import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  showCreateRaindropForm: false,
  showCancelRaindropForm: false,
};

const createRaindropSlice = createSlice({
  name: 'createRaindrop',
  initialState,
  reducers: {
    setShowCreateRaindropForm: (state, { payload }) => {
      state.showCreateRaindropForm = payload;
    },
    setShowCancelRaindropForm: (state, { payload }) => {
      state.showCancelRaindropForm = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: createRaindropReducer } = createRaindropSlice;
export const { setShowCreateRaindropForm, setShowCancelRaindropForm } = createRaindropSlice.actions;
